import React from "react";

interface PropertyDetailProps {
  label: string;
  value?: string;
  showUnit?: boolean;
  children?: React.ReactNode;
}

const PropertyDetails: React.FC<PropertyDetailProps> = ({
  label,
  children,
}) => {
  return (
    <div className="flex justify-between">
      <div className="flex items-center gap-1 homepage-text-sm ">
        <span>{label} </span>
      </div>
      <div className="flex items-center">
        {children}
      </div>
    </div>
  );
};

export default PropertyDetails;
